import { useEffect } from 'react';

import MiuThemeProvider from '@toolbox/style/theme/common/ThemeProvider/ThemeProvider';
import { OverlayCmp } from '@widget/toolbox/components';
import { BREAKPOINTS, useBreakpoint } from '@widget/utils/useBreakpoint';

export interface FloatingButtonWrapperProps {
  children: React.ReactNode;
  showWhenListenerIsInactive?: boolean;
  overlayHeight?: number;
}

export const FloatingButtonWrapper = ({
  children,
  showWhenListenerIsInactive,
  overlayHeight,
}: FloatingButtonWrapperProps) => {
  const breakpoint = useBreakpoint() || '';
  const isPhoneScreen = [BREAKPOINTS.xs, BREAKPOINTS.sm].includes(breakpoint);

  useEffect(() => {
    if (isPhoneScreen) {
      document.body.style.paddingBottom = '90px';
    } else {
      document.body.style.paddingBottom = '';
    }
  }, [isPhoneScreen]);
  if (!isPhoneScreen) {
    return <>{children}</>;
  }
  return (
    <OverlayCmp
      showWhenListenerIsInactive={showWhenListenerIsInactive}
      overlayHeight={overlayHeight}
    >
      <>{children}</>
    </OverlayCmp>
  );
};

export const MUIWrapper = ({
  children,
  showWhenListenerIsInactive,
  overlayHeight,
}: FloatingButtonWrapperProps) => {
  return (
    <MiuThemeProvider>
      <FloatingButtonWrapper
        showWhenListenerIsInactive={showWhenListenerIsInactive}
        overlayHeight={overlayHeight}
      >
        {children}
      </FloatingButtonWrapper>
    </MiuThemeProvider>
  );
};
